



































































import BaseButton from '@/components/BaseButton.vue';
import BaseDropdownMenu from '@/components/BaseDropdownMenu.vue';
import IconChevronD from '@/components/icons/IconChevronD.vue';
import IconDownloadCloud from '@/components/icons/IconDownloadCloud.vue';
import { GenericGroup } from '@/models/requests-and-responses/grupos';
import { post } from '@/services/http';
import axios, { AxiosError } from 'axios';
import msg from '@/services/userMsg';
import Vue from 'vue';
import { propOfType, propOfTypeArrayOf, isStaging } from '@/services/utils';
import store from '@/services/store';
import { errorCodeFromAxiosError } from '@/models/ErrorCode';

export default Vue.extend({
  name: 'YearReportSelector',
  components: {
    BaseDropdownMenu,
    IconChevronD,
    IconDownloadCloud,
  },
  props: {
    showGroups: propOfType(Boolean),
    auditedGroups: propOfTypeArrayOf<GenericGroup>(),
    clientID: propOfType(Number),
    // Recorridos only inicializada en false, para que no se muestre el selector de año
    carpoolOnly: propOfType<Boolean>(false),
  },
  data() {
    return {
      yearIsOpen: false,
      groupsIsOpen: false,
      yearSelected: new Date().getFullYear(),
      groupSelected: this.auditedGroups[0]?.id || 0,
      reportLoading: false,
    };
  },
  computed: {
    groupLabel(): string {
      return this.auditedGroups.find((group) => group.id === this.groupSelected)?.alias || '';
    },
    years() {
      const start = new Date().getFullYear();
      const end = 2022;
      return Array.from({ length: start - end + 1 }, (_, i) => start - i);
    },
    since(): string {
      return `${this.yearSelected}-01-01`;
    },
    until(): string {
      return `${this.yearSelected}-12-31`;
    },
    corporateAccount(): number | null {
      const account = store.getters.selectedAccount;
      return account.tag === 'corporateAccount' ? account.account.idCuentaSgv : null;
    },
    isStaging(): boolean {
      return isStaging();
    },
  },
  methods: {
    selectGroup(group: number) {
      this.groupSelected = group;
      this.groupsIsOpen = false;
      this.$emit('groupSelected', [group]);
    },
    selectYear(year: number) {
      this.yearSelected = year;
      this.yearIsOpen = false;
      this.$emit('yearSelected', year);
    },
    downloadReportOLD() {
      if (!this.corporateAccount) {
        this.$toast.error(msg.getError('uknown'));
        return;
      }
      const reportTS = localStorage.getItem(`${this.corporateAccount}-pedidos-ts`) as string | null;
      if (reportTS && new Date().getTime() - new Date(reportTS).getTime() < 600000) {
        this.$toast.info(msg.getInfo('report_already_requested'));
        this.reportLoading = false;
        return;
      }
      this.reportLoading = true;
      const endpoint = this.carpoolOnly ? '/pedidos/v1/reporte/recorridos-fijos' : '/pedidos/v1/reporte/pedidos';
      post(endpoint, undefined, {
        params: {
          idClient: this.clientID,
          since: this.since,
          until: this.until,
          provider: 'InPunto',
          areMyOrders: false,
          status: 'confirmado,finalizado,calificado',
          group: this.showGroups ? this.groupSelected : '',
        },
      })
        .then(() => {
          localStorage.setItem(`${this.corporateAccount}-pedidos-ts`, new Date().toISOString());
          this.$toast.success(msg.getSuccess('report_requested'));

          this.$logEvent(
            'descarga_reporte',
            { tipo_reporte: msg.getReports('pedidos') },
          );
        })
        .catch((error: AxiosError) => {
          const errorCode = errorCodeFromAxiosError(error);
          if (errorCode === 'internal_error') {
            this.$toast.error(msg.getError('error_on_report'));
          } else {
            this.$toast.error(msg.getError(errorCode));
          }
        })
        .finally(() => {
          this.reportLoading = false;
        });
    },
    downloadReport() {
      if (!this.corporateAccount) {
        this.$toast.error(msg.getError('uknown'));
        return;
      }
      const reportTS = localStorage.getItem(`${this.corporateAccount}-pedidos-ts`) as string | null;
      if (reportTS && new Date().getTime() - new Date(reportTS).getTime() < 600000) {
        this.$toast.info(msg.getInfo('report_already_requested'));
        this.reportLoading = false;
        return;
      }
      this.reportLoading = true;
      const endpoint = '/pedidos/v2/reporte/anual';
      post(endpoint, undefined, {
        params: {
          idClient: this.clientID,
          year: this.yearSelected,
          group: this.showGroups ? this.groupSelected : '',
          carpoolOnly: this.carpoolOnly,
        },
      })
        .then(() => {
          localStorage.setItem(`${this.corporateAccount}-pedidos-ts`, new Date().toISOString());
          this.$toast.success(msg.getSuccess('report_requested'));

          this.$logEvent(
            'descarga_reporte',
            { tipo_reporte: msg.getReports('pedidos') },
          );
        })
        .catch((error: AxiosError) => {
          const errorCode = errorCodeFromAxiosError(error);
          if (errorCode === 'internal_error') {
            this.$toast.error(msg.getError('error_on_report'));
          } else {
            this.$toast.error(msg.getError(errorCode));
          }
        })
        .finally(() => {
          this.reportLoading = false;
        });
    },
  },
  mounted() {
    // Code to run when the component is mounted goes here
  },
});
